import { Col, Row } from "antd";
import { FOOTER_APP_ICON } from "assets";
import { Link } from "react-router-dom";

import {
  FOOTER_FB,
  FOOTER_INSTA,
  FOOTER_TWITTER,
  FOOTER_LINKEDIN,
} from "assets";
import { ReactSVG } from "react-svg";

const Footer = () => {
  return (
    <footer>
      <div className="container footer-inner">
        <div className="footer-inner-left">
          <img src={FOOTER_APP_ICON} alt="footer-app-icon" />
          <p className="color-white jakarta-sans-font">
            With lots of unique blocks, you can easily build a page without
            coding. Build your next landing page.
          </p>
          <div className="footer-social-icons">
            {footerSocialIcons.map((footerSocialIcon, index) => (
              <ReactSVG src={footerSocialIcon} key={index} />
            ))}
          </div>
        </div>
        <Row className="footer-inner-right" gutter={[20, 40]}>
          {footerData.map((column, index) => (
            <Col xs={12} sm={12} md={6} className="footer-column" key={index}>
              <span className="color-white">{column.title}</span>
              <ul>
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      className="jakarta-sans-font color-white"
                      to={link.url}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
      </div>
    </footer>
  );
};

export default Footer;

const footerSocialIcons = [
  FOOTER_FB,
  FOOTER_INSTA,
  FOOTER_TWITTER,
  FOOTER_LINKEDIN,
];

const footerData = [
  {
    title: "Company",
    links: [
      { name: "About us", url: "#" },
      { name: "Contact us", url: "#" },
      { name: "Careers", url: "#" },
      { name: "Blogs", url: "#" },
    ],
  },
  {
    title: "Product",
    links: [
      { name: "Features", url: "#" },
      { name: "Pricing", url: "#" },
      { name: "News", url: "#" },
      { name: "Help desk", url: "#" },
      { name: "Support", url: "#" },
    ],
  },
  {
    title: "Services",
    links: [
      { name: "Cloud Services", url: "#" },
      { name: "Cybersecurity", url: "#" },
      { name: "Software Development", url: "#" },
      { name: "IT Consulting & IT Services", url: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { name: "Privacy Policy", url: "#" },
      { name: "Terms & Conditions", url: "#" },
      { name: "Return Policy", url: "#" },
    ],
  },
];
